export function sortObjectsBasedOnReferenceOrder<
  KeyName extends keyof T,
  T extends Record<string, any>,
>(arrayToSort: T[], referenceOrder: string[], keyName: KeyName) {
  return arrayToSort.sort((a, b) => {
    const orderA = referenceOrder.indexOf(a[keyName]);
    const orderB = referenceOrder.indexOf(b[keyName]);
    if (orderA === -1 && orderB === -1) {
      return 0;
    }
    if (orderA === -1) {
      return 1;
    }
    if (orderB === -1) {
      return -1;
    }
    return orderA - orderB;
  });
}
